import log from './log'

const zhCN = { log: log.zhCN }
const enUS = { log: log.enUS }
export default { zhCN, enUS }